/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { Tooltip } from '@mui/material';

import { useNotificationsStyles } from '../Notifications.styles';

type TwoSwitchesHeadingProps = {
  groupNameText: string;
  groupNameTooltip: string;
  firstHeadingText: string;
  secondHeadingText: string;
};

export function TwoSwitchesHeading(props: TwoSwitchesHeadingProps) {
  const { firstHeadingText, groupNameText, groupNameTooltip, secondHeadingText } = props;
  const classes = useNotificationsStyles();
  return (
    <>
      <Tooltip title={groupNameTooltip} placement="top-start">
        <div className={classes.groupName}>{groupNameText}</div>
      </Tooltip>
      <div className={classes.notificationType}>{firstHeadingText}</div>
      <div className={classes.notificationType}>{secondHeadingText}</div>
    </>
  );
}
